import { bool, object, string, func, oneOfType, arrayOf } from 'prop-types'
import Div from '@ui/layout/Div'
import Alert from '@ui/elements/Alert'
import Buttons from '@ui/elements/Buttons'

const RadioType = ({
  name,
  onClick,
  cssClass,
  canCreate,
  creationModalCaller,
  options,
  label = false,
  help = false,
  error,
  value
}) => {
  const renderOptionChilds = option => {
    return option.childs.map(child => {
      return <li key={`sub-opt-${child.value}-${child.label}`}>{renderOption(child, 'sub-opt')}</li>
    })
  }

  const renderOption = (option, cssClass = 'main-opt') => {
    return (
      <label className={`checkbox ${cssClass}`} htmlFor={`input-${name}`} key={`${option.value}-${option.label}`}>
        <input type="radio" id={`input-${name}`} name={name} onClick={() => onClick(name, option.value)} checked={option.value == value || option.checked} value={option.value} onChange={() => { }} />
        {option.label}
      </label>
    )
  }

  const renderOptions = options.map(option => {
    return (
      <Div cssClass='checkbox-col' key={`${option.label}-${name}`}>
        {renderOption(option)}
        {typeof option.childs !== 'undefined' && option.childs.length ? <ul className='sub-opts'> {renderOptionChilds(option)} </ul> : ''}
      </Div>
    )
  })

  return (
    <Div cssClass={`field ${cssClass}`}>
      {label && <label className="label">{label}</label>}
      <Div cssClass="control">
        {renderOptions}
        {canCreate ? <Buttons buttons={{ icon: 'icon-add_circle', callback: creationModalCaller }} /> : <></>}
      </Div>
      {help && <p className="help">{help}</p>}
      {error && <Alert cssClass='clear' type='is-danger' message={error} />}
    </Div>
  )
}

RadioType.propTypes = {
  name: string,
  onClick: func,
  cssClass: string,
  canCreate: bool,
  creationModalCaller: func,
  options: oneOfType([arrayOf(object), object]),
  help: bool,
  label: string,
  error: string,
  value: string
}

export default RadioType
